import { Box, Modal } from '@mui/material';
import router from 'next/router';
import SpecialBtn from '../Mint/SpecialBtn';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';


//
function RevealModal(props: any) {

    //
    function gotoDetails() {
        router.push("/dragon/" + props.nftData.mint);
    }

    const STONE_RUNES_SEQ = [3, 2, 1, 4, 3, 2, 1, 4, 4, 3, 2, 1, 4, 3, 2, 1];

    //
    function runesUi() {
        return (
            <Box sx={{
                display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row",
                width: "100%", flexWrap: "wrap", padding: "5px"
            }}>
                {
                    props.nftData.dna.map((gene: any, i: number) => {
                        return (
                            <Box key={i} sx={{ width: "45px", position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <img src={"/mint/Rune_0" + STONE_RUNES_SEQ[i] + ".png"} style={{ width: "45px" }} />

                                <Box sx={{ position: "absolute", color: "#00f1ff", fontSize: "24px", fontWeight: 700, top: "12%" }}>{gene}</Box>
                            </Box>
                        )
                    })
                }
            </Box>
        )
    }

    //
    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">

            <Box className={props.className}>
                {props.open && props.nftData &&
                    <Box className="r-modal-container" style={{ padding: "0px", position: "relative", background: "", maxWidth: "700px", margin: "auto" }}>
                        <img src="/mint/Flair_Static_Gold_03.png" style={{ width: "100%" }} />
                        <img src="/mint/Small-Particles2.gif" style={{ width: "80%", position: "absolute", top: 0 }} />

                        <Box sx={{ position: "absolute", maxWidth: "100%", width: "100%", background: "", padding: "22%", top: "-2%" }}>
                            <Box className="r-modal-imgs-container" style={{ position: "relative", marginTop: "-5%", display: "flex", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
                                <img className="r-modal-img1" src={'/mint/Frame_' + (props.nftData.score ? props.nftData.score.label : "Common") + '.png'} />
                                <img className="r-modal-img2" src={props.nftData.image} />

                                {props.nftData.score &&
                                    <span style={{ position: "absolute", bottom: "-22px", fontSize: "16px", color: "#ddae65", fontWeight: 700 }}>
                                        {props.nftData.score.label}
                                    </span>
                                }
                            </Box>
                        </Box>

                        <Box sx={{
                            display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", width: "100%",
                            position: "relative", top: "-15px",
                            color: "#c28a4c", fontWeight: 700, fontSize: "20px", lineHeight: 1.1
                        }}>
                            <Box>{props.nftData.name}</Box>
                            <Box>Released!</Box>
                        </Box>

                        {runesUi()}

                        <Box sx={{ margin: "10px 0px 10px 0px" }}>
                            <SpecialBtn
                                label="Show Details"
                                variant="gold"
                                width="180px"
                                height="40px"
                                labelSize="17px"
                                textColor="#2c1e13"
                                inProg={false}
                                onClick={gotoDetails} disabled={false}
                            />
                        </Box>
                    </Box>}
            </Box>
        </Modal >
    )
}

// Default style!
const RevealModalS = styled(RevealModal)({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "100%",
    height: "100%",
    borderRadius: 3,
    //boxShadow: 24,
    outline: "none",
    overflow: "hidden",
    //padding: "30px",
    //backgroundImage: "url(/mint/Flair_Static_gold.png)",
    background: "#000000cc",
    //backgroundSize: "100%",
    //backgroundRepeat: "no-repeat",
    // backgroundPosition: "42%",
    //padding: "0px 180px 0px 180px",
    //border: "2px solid red",
    overflowY: "auto",
    ".r-modal-container": {
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        position: "relative",
        //marginTop: "-20%"
        //background: "red",
        zIndex: 10000

    },
    ".r-modal-imgs-container": {
        position: "relative",
        //minWidth: "200px",
        //marginTop: "-20%"
    },
    ".r-modal-img1": {
        width: "100%", borderRadius: "0px"
    },
    ".r-modal-img2": {
        width: "93%",
        position: "absolute",
        top: "5%",
    }

});

// Export
export default RevealModalS;